export function getPasswordProgress (password: string): number {
  let progress = 0

  // Length
  if (password.length) {
    progress += 5
  }
  // Length
  if (password.length > 8) {
    progress += 15
  }
  if (password.length > 5) {
    progress += 10

    if (/\d/.test(password)) {
      progress += 10
    }
    if (/\W/.test(password)) {
      progress += 20
    }
  }
  if (/[A-Z]/.test(password)) {
    progress += 10
  }
  if (/[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /\d/.test(password) &&
    /\W/.test(password)
  ) {
    progress += 30
  }

  return Math.min(100, progress) / 100
}

export function getPasswordColor (progress: number): string {
  return ['negative', 'warning', 'positive'][Math.floor(progress * 100 / 40)]
}
